<template>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <h2 class="im-title">{{ $t("home.partnership_entrepreneur_title") }}</h2>
    <div class="row">
      <div class="col-12 col-sm-12 col-lg-8 col-xl-6">
        <div>
          <StatusMessage ref="statusMessageSuccess"></StatusMessage>

          <div ref="eleName" class="mb-3 required">
            <label for="partEntre_name">{{ $t("partnership.name") }}: *</label>
            <input
              id="partEntre_name"
              v-model.trim="partEntre_name"
              type="text"
              class="form-control"
              :placeholder="$t('partnership.name_placeholder')"
              maxlength="40"
              required
            />
          </div>
          <StatusMessage ref="statusMessageName"></StatusMessage>

          <div ref="eleEmail" class="mb-3 required">
            <label for="partEntre_email">{{ $t("partnership.email") }}: *</label>
            <input
              id="partEntre_email"
              v-model.trim="partEntre_email"
              type="email"
              class="form-control"
              placeholder="name@example.com"
              maxlength="60"
              required
            />
          </div>
          <StatusMessage ref="statusMessageEMail"></StatusMessage>

          <div ref="elePhone" class="mb-3 required">
            <label for="partEntre_phone">{{ $t("partnership.phone") }}: *</label>
            <input
              id="partEntre_phone"
              v-model.trim="partEntre_phone"
              type="tel"
              class="form-control"
              placeholder="+359..."
              maxlength="30"
              required
            />
          </div>
          <StatusMessage ref="statusMessagePhone"></StatusMessage>

          <div ref="eleDescription" class="mb-3 required">
            <label for="partEntre_description"
              >{{ $t("partnership.project_description") }}: *</label
            >
            <textarea
              id="partEntre_description"
              v-model.trim="partEntre_description"
              class="form-control"
              rows="5"
              maxlength="1000"
              required
            ></textarea>
          </div>
          <StatusMessage ref="statusMessageDescription"></StatusMessage>

          <div class="mb-3 mb-0">
            <label>
              {{ $t("partnership.attach_files") }}<br />
              {{ $t("partnership.allowed_formats") }}
            </label>
          </div>

          <div class="input-group mb-3">
            <div class="custom-file">
              <input
                id="partEntre_file1"
                ref="partEntre_file1"
                type="file"
                class="custom-file-input"
                @change="fileSetName($event, 1)"
              />
              <label for="partEntre_file1" class="custom-file-label" v-text="file1"></label>
            </div>
          </div>
          <StatusMessage ref="statusMessageFile1"></StatusMessage>

          <div class="input-group mb-3">
            <div class="custom-file">
              <input
                id="partEntre_file2"
                ref="partEntre_file2"
                type="file"
                class="custom-file-input"
                @change="fileSetName($event, 2)"
              />
              <label for="partEntre_file2" class="custom-file-label" v-text="file2"></label>
            </div>
          </div>
          <StatusMessage ref="statusMessageFile2"></StatusMessage>

          <div class="input-group mb-3">
            <div class="custom-file">
              <input
                id="partEntre_file3"
                ref="partEntre_file3"
                type="file"
                class="custom-file-input"
                @change="fileSetName($event, 3)"
              />
              <label for="partEntre_file3" class="custom-file-label" v-text="file3"></label>
            </div>
          </div>
          <StatusMessage ref="statusMessageFile3"></StatusMessage>

          <div ref="eleCaptcha" class="mb-3">
            <ReCaptcha ref="recaptcha"></ReCaptcha>
          </div>
          <StatusMessage ref="statusMessageRobot"></StatusMessage>

          <button
            type="button"
            class="btn btn-primary btn-block"
            :class="{ disabled: submitDisabled }"
            @click="formSubmit"
          >
            {{ $t("partnership.send") }}
          </button>

          <StatusMessage ref="statusMessageSubmit"></StatusMessage>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import StatusMessage from "../shared/StatusMessage.vue";
  import ReCaptcha from "./ReCaptcha.vue";

  export default {
    name: "PartnershipEntrepreneurSection",
    components: {
      StatusMessage,
      ReCaptcha,
    },
    data() {
      return {
        submitDisabled: false,

        fileDefault: "Choose file",
        file1: "",
        file2: "",
        file3: "",
        partEntre_name: "",
        partEntre_email: "",
        partEntre_phone: "",
        partEntre_description: "",
        fileTypesAllowed: [
          "application/zip", // zip
          "application/x-zip-compressed", // zip
          "application/pdf", // pdf
          "application/ods", // ods
          "application/vnd.oasis.opendocument.spreadsheet", // ods
        ],
      };
    },
    created() {
      this.fileDefault = this.$t("common.choose_file");
      this.file1 = this.fileDefault;
      this.file2 = this.fileDefault;
      this.file3 = this.fileDefault;
    },
    methods: {
      fileSetName(event, objectid) {
        if (event.target.files.length > 0) {
          if (this.fileTypesAllowed.indexOf(event.target.files[0].type) < 0) {
            this.resetFileInput("partEntre_file" + objectid);
            this["file" + objectid] = this.fileDefault;
            this.$refs["statusMessageFile" + objectid].displayErrorMessage("file");
          } else {
            this["file" + objectid] = event.target.files[0].name;
            this.$refs["statusMessageFile" + objectid].resetStatusMessage();
          }
        } else {
          this["file" + objectid] = this.fileDefault;
          this.$refs["statusMessageFile" + objectid].resetStatusMessage();
        }
      },
      formSend(formData) {
        this.$root.request
          .post("/partnership_entrepreneur", formData)
          .catch(this.$root.responseErrorHandler)
          .then(this.$root.responseMiddleware)
          .then((response) => {
            // console.dir(response);

            this.submitDisabled = false;

            if (response.success) {
              this.$root.scrollToTop();
              this.$refs.statusMessageSuccess.displaySuccessMessage("contact_us_sent");
              this.resetForm();
            } else if (response.error && response.error.message) {
              this.$refs.statusMessageSubmit.displayErrorMessage(response.error.message);
            }
          });
      },
      formSubmit() {
        if (this.submitDisabled) {
          return;
        }

        // Name
        if (this.partEntre_name == "") {
          this.$refs.statusMessageName.displayErrorMessage("required", {
            attribute: this.$t("partnership.name"),
          });
          this.$root.scrollTo(
            0,
            this.$refs.eleName.offsetTop + this.$refs.eleName.offsetParent.offsetTop
          );
          return;
        }
        this.$refs.statusMessageName.resetStatusMessage();

        // EMail
        if (this.partEntre_email == "") {
          this.$refs.statusMessageEMail.displayErrorMessage("required", {
            attribute: this.$t("partnership.email"),
          });
          this.$root.scrollTo(
            0,
            this.$refs.eleEmail.offsetTop + this.$refs.eleEmail.offsetParent.offsetTop
          );
          return;
        }
        if (!this.$root.isEmailValid(this.partEntre_email)) {
          this.$refs.statusMessageEmail.displayErrorMessage("invalid_email");
          this.$root.scrollTo(
            0,
            this.$refs.eleEmail.offsetTop + this.$refs.eleEmail.offsetParent.offsetTop
          );
          return;
        }
        this.$refs.statusMessageEMail.resetStatusMessage();

        // Phone
        if (this.partEntre_phone == "") {
          this.$refs.statusMessagePhone.displayErrorMessage("required", {
            attribute: this.$t("partnership.phone"),
          });
          this.$root.scrollTo(
            0,
            this.$refs.elePhone.offsetTop + this.$refs.elePhone.offsetParent.offsetTop
          );
          return;
        }
        this.$refs.statusMessagePhone.resetStatusMessage();

        // Description
        if (this.partEntre_description == "") {
          this.$refs.statusMessageDescription.displayErrorMessage("required", {
            attribute: this.$t("partnership.project_description"),
          });
          this.$root.scrollTo(
            0,
            this.$refs.eleDescription.offsetTop + this.$refs.eleDescription.offsetParent.offsetTop
          );
          return;
        }
        this.$refs.statusMessageDescription.resetStatusMessage();

        // ReCaptcha
        if (
          typeof this.$refs.recaptcha.verifyKey !== "string" ||
          this.$refs.recaptcha.verifyKey.length < 200
        ) {
          this.$refs.recaptcha.resetRecaptcha();
          this.$refs.statusMessageRobot.displayErrorMessage("recaptcha");
          this.$root.scrollTo(
            0,
            this.$refs.eleCaptcha.offsetTop + this.$refs.eleCaptcha.offsetParent.offsetTop
          );
          return;
        }
        this.$refs.statusMessageRobot.resetStatusMessage();

        // Form Data
        var formData = new FormData();
        formData.set("partEntre_name", this.partEntre_name);
        formData.set("partEntre_email", this.partEntre_email);
        formData.set("partEntre_phone", this.partEntre_phone);
        formData.set("partEntre_description", this.partEntre_description);
        formData.set("partEntre_captcha", this.$refs.recaptcha.verifyKey);

        // File(s)
        for (var i = 1; i < 4; i++) {
          var object = "partEntre_file" + i;
          var status = "statusMessageFile" + i;
          if (this.$refs[object].files.length > 0) {
            if (this.fileTypesAllowed.indexOf(this.$refs[object].files[0].type) < 0) {
              this.$refs[status].displayErrorMessage("file_name", {
                name: this.$refs[object].files[0].name,
              });
              return;
            }
            this["file" + i] = this.$refs[object].files[0].name;
            formData.set(object, this.$refs[object].files[0]);
          }
        }

        this.submitDisabled = true;

        this.formSend(formData);
      },
      resetFileInput(object) {
        this.$refs[object].value = "";
        this.$refs[object].type = "text";
        this.$refs[object].type = "file";
      },
      resetForm() {
        this.partEntre_name = "";
        this.partEntre_email = "";
        this.partEntre_phone = "";
        this.partEntre_description = "";

        this.file1 = this.file2 = this.file3 = this.fileDefault;

        // tricky reset of the file input field
        for (var i = 1; i < 4; i++) {
          this.resetFileInput("partEntre_file" + i);
        }

        this.$refs.recaptcha.resetRecaptcha();
      },
    },
  };
</script>
